import React, { useEffect, useState } from "react";
import AdminDashboard from "../AdminDashboard/AdminDashboard";
import { GetLocalStorageParsed } from "../../../Utils/Utils";
import { useLocation, useNavigate } from "react-router-dom";
import { saveAs } from "file-saver"; // Import file-saver
import { BsChevronLeft } from "react-icons/bs";
import { HomeIcon } from "../../../components/Application/ApplicationIcon";
import { Table } from "react-bootstrap";
import NotFoundTable from "../../../components/notFound/NotFoundTable";
import TotalRecords from "../../../components/notFound/TotalRecords";

const OldDocumentViewAdmin = () => {
  const userDetail = GetLocalStorageParsed("userDetail");
  const location = useLocation();
  const [categoryFileData, setCategoryFileData] = useState(null);
  const navigate = useNavigate();
  const [tableDataLoaded, setTableDataLoaded] = useState(false);
  const [totalRecords, setTotalRecords] = useState(0);

  useEffect(() => {
    if (!userDetail) {
      navigate("/"); // Redirect if user is not authenticated
    } else {
      if (location?.state && location?.state?.fileData) {
        setCategoryFileData(location?.state?.fileData);
        setTableDataLoaded(true);
        setTotalRecords(location?.state?.fileData?.length ? location?.state?.fileData?.length : 0);
      } else{
        setTotalRecords(0);
        setTableDataLoaded(true);
      }
    }
  }, [location?.state, userDetail]);

  // Function to trigger file download
  const handleDownload = (filePath, fileName) => {
    fetch(filePath)
      .then((response) => response.blob()) // Convert to Blob
      .then((blob) => saveAs(blob, fileName)); // Save as a file
  };

  return (
    <AdminDashboard>
      <div className="aod-outer">
        <div className="aod-bottom">
          <div className="page_heading">
            <h5>Old Documents</h5>
          </div>
          <div className="ap-breadcrumb pt-2 pb-2 mb-2 adm-breadcrumb">
            <div>
              <HomeIcon />
              <b onClick={() => navigate("/admin/")}>Home / </b>
              <span>Old Documents Details</span>
            </div>
          </div>
          <div className="aod-top user-aod-top mb-3">
            <div className=" text-center mb-2 adm-head">
              <button
                onClick={() => {
                  navigate("/admin/old-document", {
                    state: {
                      data: location?.state?.categoryData,
                    },
                  });
                }}
              >
                <BsChevronLeft /> Back
              </button>
            </div>
          </div>
          
          <div className="row">
            {totalRecords > 0 ? <div className="row py-4 pb-0 pt-0">
              <div className="col-md-10"></div>
              <TotalRecords totalRecords={totalRecords}></TotalRecords>
            </div> : <></>}
            <div className="reciept-table table-responsive mt-2">
              <div className="reciept-table table-responsive mt-2">
                <div className="ad-reg-table">
                  <Table size="sm" className="ad-cat-table">
                    <thead className="">
                      <tr role="row">
                        <th>S.No</th>
                        <th>File Name</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {categoryFileData?.length > 0 ? (
                        categoryFileData?.map((item, index) => (
                          <tr key={index}>
                            <td>{index + 1}</td>
                            <td>{item.name}</td>
                            <td>
                              {item.path ? (
                                <button
                                  className="btn admin-theme-btn"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    handleDownload(item.path, item.name); // Trigger file download
                                  }}
                                >
                                  Download
                                </button>
                              ) : (
                                "--"
                              )}
                            </td>
                          </tr>
                        ))
                      ) : tableDataLoaded ? (
                        <NotFoundTable colSpan="3"></NotFoundTable>
                      ) : (
                        <></>
                      )}
                    </tbody>
                  </Table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </AdminDashboard>
  );
};

export default OldDocumentViewAdmin;
